<section class="user-filters__container">
  <div class="user-filters__search">
    <scc-dsm3-search-control
      [formGroup]="formGroup"
      formName="search"
      placeholder="Nome, Utilizador"
      (onApplySearch)="onSearch($event)"
    ></scc-dsm3-search-control>
  </div>
</section>
<div class="user-filters__add-user" *ngIf="createPermissions">
  <button (click)="userService.createUser(route)" class="user-filters__add-btn">
    Criar novo utilizador
    <span class="user-filters__add-wrapper"><i class="user-filters__add-icon icon icon--small icon--add"></i></span>
  </button>
</div>
